import { store } from "../app/store";
import { nanoid } from "@reduxjs/toolkit";
import { openConfirm, confirmTopModal, cancelTopModal } from "../features/modal/modalSlice";

const resolvers = new Map<string, (v: boolean) => void>();
const onAcceptFns = new Map<string, () => void>();
const onCloseFns = new Map<string, () => void>();

type ConfirmOpts = {
  title: string;
  subtitle?: string;
  confirmText?: string;
  cancelText?: string;
};

export function confirm(options: ConfirmOpts, onConfirm?: () => void): Promise<boolean> {
  const id = nanoid();
  store.dispatch(openConfirm({ id, ...options }));
  if (onConfirm) onAcceptFns.set(id, onConfirm);

  return new Promise<boolean>((resolve) => {
    resolvers.set(id, resolve);
  });
}

export function registerConfirm(
  id: string,
  opts?: {
    onAccept?: () => void;
    onClose?: () => void;
  }
) {
  if (opts?.onAccept) onAcceptFns.set(id, opts.onAccept);
  if (opts?.onClose) onCloseFns.set(id, opts.onClose);
}

export function resolveConfirm(id: string, value: boolean) {
  const resolve = resolvers.get(id);
  if (resolve) {
    resolve(value);
    resolvers.delete(id);
  }

  if (value) {
    const fn = onAcceptFns.get(id);
    try {
      fn?.();
    } finally {
      onAcceptFns.delete(id);
      onCloseFns.delete(id);
    }
    store.dispatch(confirmTopModal());
  } else {
    const fn = onCloseFns.get(id);
    try {
      fn?.();
    } finally {
      onAcceptFns.delete(id);
      onCloseFns.delete(id);
    }
    store.dispatch(cancelTopModal());
  }
}

export function createConfirmPromise(id: string) {
  return new Promise<boolean>((resolve) => {
    resolvers.set(id, resolve);
  });
}
